import React from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { GallectionType } from '@wix/da-shared-react/pkg/types/gallection';
import FolderContent from '../FolderContent';
import MobileGallectionHeader from '../MobileGallectionHeader';

import s from './GallectionSimpleView.scss';

export interface Props {
  currentFolder?: PapiGallection;
}

const MobileGallectionSimpleView: React.FC<Props> = ({ currentFolder }) => {
  const noFavouritesSearch = useFlag('no_favourites_search');

  const isGallery = currentFolder?.type === GallectionType.GALLERY;
  const disableSearch = !isGallery && noFavouritesSearch;

  return (
    <div className={s['root']}>
      <ErrorBoundary debugComponent="MobileGallectionSimpleView">
        <MobileGallectionHeader
          currentFolder={currentFolder}
          disableSearch={disableSearch}
        />
        <div id="sub-folder-gallery">
          {currentFolder && (
            <FolderContent
              key={currentFolder?.folderId}
              folderId={currentFolder?.folderId || 0}
            />
          )}
        </div>
      </ErrorBoundary>
    </div>
  );
};
MobileGallectionSimpleView.displayName = 'MobileGallectionSimpleView';

export default MobileGallectionSimpleView;
